var MembersStrings = {
    addMembersForm: {
        modalTitle: function () { return 'Add Members'; },
        modalDescription: function () {
            return "Enter the email address of each member separated by commas, newlines or spaces. We'll send them an email invitation to access their benefits.";
        },
        modalDescriptionPlusLimitation: function (remaining, totalCount) {
            return "You have " + remaining + " out of " + totalCount + " spots left on your Team plan.";
        },
    },
    informCannotAddEmailContent: {
        title: {
            singleFail: function () { return "1 person unable to be added to team account"; },
            multipleFail: function (count) {
                return count + " people unable to be added to team account";
            },
        },
        inviteToTeamError: {
            singleFail: function () {
                return "The following person cannot be added because they have already been invited to another team.";
            },
            multipleFail: function (count) {
                return "The following " + count + " people cannot be added because they have already been invited to another team.";
            },
        },
        button: {
            primaryText: function () { return 'Got It'; },
        },
    },
    membersPageSubtitleText: function (totalCount, limit) {
        return totalCount + " out of " + limit;
    },
    limitationErrorBannerTitle: function () {
        return "You've exceeded the maximum number of members";
    },
    limitationErrorBannerDescription: function (remaining) {
        return "You can only add " + remaining + " members to your Team plan. Contact sales to upgrade to the Enterprise plan which offers unlimited spots.";
    },
    membersLimitModalTitle: function () { return 'Upgrade to add members'; },
    membersLimitModalDescription: function (limit) {
        return "You have a limit of " + limit + " members for the Small Team plan. To add more members, contact sales to upgrade to the Corporate Ordering plan.";
    },
    membersLimitModalContactSalesButtonText: function () { return 'Contact Sales'; },
    membersLimitModalContactCancelButtonText: function () { return 'Cancel'; },
    addMemberError: {
        default: function () { return 'There was an error.'; },
        exceedEmailLimit: {
            singleFail: function (limit, numOfEmailToRemove) {
                return "You have exceeded the limit of " + limit + " email addresses. Please remove " + numOfEmailToRemove + " email address to continue.";
            },
            multipleFail: function (limit, numOfEmailToRemove) {
                return "You have exceeded the limit of " + limit + " email addresses. Please remove " + numOfEmailToRemove + " email addresses to continue.";
            },
        },
    },
    addSuccessToast: {
        singleAdd: function () { return '1 email added successfully.'; },
        multipleAdd: function (count) { return count + " emails added successfully."; },
    },
    resendWorkPortalInviteBanner: {
        singleEmployeeText: function (totalPendingCount) {
            return totalPendingCount + " employee has not accepted their invite to the work benefits.";
        },
        multiEmployeesText: function (totalPendingCount) {
            return totalPendingCount + " employees have not accepted their invites to the work benefits.";
        },
        primaryActionContent: function () { return 'Resend Invites'; },
    },
    resendInvitesConfirmationModal: {
        title: function (totalPendingCount, isPlural) {
            return "Resend Invites to " + totalPendingCount + " Employee" + (isPlural ? 's' : '');
        },
        errorTitle: function () { return 'Unable to Resend Invites'; },
        content: function (totalPendingCount, isPlural) {
            return "Would you like to resend invites to " + totalPendingCount + " pending employee" + (isPlural ? 's' : '') + "?";
        },
        errorContent: function () {
            return "We couldn\u2019t resend the invites. You can try again later.";
        },
        isSendingContent: function () {
            return 'This may take up to a minute. Do not close this modal.';
        },
        resendButton: function () { return 'Resend'; },
        cancelButton: function () { return 'Cancel'; },
        errorCancelButon: function () { return 'Got it'; },
    },
    resendInvitesSuccessToast: function (totalPendingCount, isPlural) {
        return totalPendingCount + " invite" + (isPlural ? 's' : '') + " resent";
    },
    employeeListActionMenu: {
        menuOptionRemoveEmployee: function () { return 'Remove employee'; },
        menuOptionRemoveAdmin: function () { return 'Remove admin access'; },
        menuOptionGrantAdmin: function () { return 'Grant admin access'; },
        menuOptionResendInvite: function () { return 'Resend invite'; },
    },
};
export default MembersStrings;
